import Marquee from 'react-fast-marquee';

const WORDS = [
  'An Italian lawyer · on your side in Italy',
  'Free preliminary claim assessment',
  'Segreto professionale · art. 622 c.p.',
  'Every step · a written, forwardable record',
  'Italian enforcement · esecuzione forzata',
];

export default function EditorialMarquee() {
  return (
    <div className="relative bg-ink-950 border-y border-white/10 py-10 md:py-14 overflow-hidden" data-testid="editorial-marquee">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="marquee-serif text-5xl md:text-7xl text-white/85 mx-16 flex items-center gap-16">
            {w}
            <span className="text-oxblood text-4xl md:text-6xl" aria-hidden>✻</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
